import { createFileRoute, redirect } from '@tanstack/react-router';

/** /settings/data-connector/inbound は既定で取り込みパイプライン一覧へ。 */
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/')({
  beforeLoad: () => {
    throw redirect({
      to: '/settings/data-connector/inbound/data-pipeline'
    });
  }
});